import React from "react";
import { useLocation } from "react-router-dom";
import { IconRotateClockwise } from "@tabler/icons-react";
import finalVideoMp4 from "../../assets/videos/video-final-cobega.mp4";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { useVideoWithSound } from "../../hooks/useVideoWithSound";
import { useVideoContinueGate } from "../../hooks/useVideoContinueGate";
import Scenario2NextCta from "../Scenario2/Scenario2NextCta";
import "../StartGame.css";
import "../Scenario1/Scenario1Intro.css";
import "./Scenario5.css";

function Scenario5Fin() {
	const location = useLocation();
	const activeScenario = getScenarioNumByPath(location.pathname);

	const { videoRef, canPlayWithSound } = useVideoWithSound({
		autoPlay: true,
		volume: 0.9,
	});
	const canContinue = useVideoContinueGate(videoRef);

	const handleReplayFromStart = () => {
		const el = videoRef.current;
		if (!el) return;
		el.currentTime = 0;
		el.play().catch(() => {});
	};

	return (
		<div className="s1-intro-page start-game-page--welcome sc5-fin-intro">
			<div className="s1-intro-inner">
				<span className="start-game-badge s1-intro-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Escenario 4 · Inversión
				</span>

				<div className="s1-intro-video-frame">
					<video
						ref={videoRef}
						autoPlay
						muted={!canPlayWithSound}
						playsInline
						preload="metadata"
						aria-label="Vídeo final Cobega"
					>
						<source src={finalVideoMp4} type="video/mp4" />
					</video>
				</div>

				<div className="s1-intro-footer">
					<button
						type="button"
						className="s1-intro-replay s1-intro-replay--icon"
						aria-label="Volver a reproducir el vídeo desde el principio"
						onClick={(e) => {
							e.preventDefault();
							handleReplayFromStart();
						}}
					>
						<IconRotateClockwise size={22} stroke={1.75} aria-hidden />
					</button>
					<Scenario2NextCta
						navigateTo={ROUTES.FINAL_SCENE}
						activeScenario={activeScenario}
						className="s1-intro-cta"
						label="Continuar"
						canContinue={canContinue}
						lockedTitle="Espera a que el vídeo comience"
					/>
				</div>
			</div>
		</div>
	);
}

export default Scenario5Fin;
